import React from "react";

const AuthBtn = (props) => {
  return (
    <div className=" ">
      <button type="submit" {...props}>
        {props.title}
      </button>
    </div>
  );
};

export default AuthBtn;
